<template>
  <span
    :class="{
      'overflow-hidden bg-grey-2 rounded-borders items-start row': showMultipleSubTargets
    }"
  >
    <task-analysis-target
      v-if="isTaskAnalysisTarget"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :focused="focused"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      :session-paused="sessionPaused"
      :session-duration-offset="sessionDurationOffset"
      :cached-current-program-trial="cachedCurrentProgramTrial"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
    <target-set-target
      v-else-if="isTargetSetTarget"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      :session-paused="sessionPaused"
      :session-duration-offset="sessionDurationOffset"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
    <interval-target
      v-else-if="isIntervalParent"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      :session-paused="sessionPaused"
      :session-duration-offset="sessionDurationOffset"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-multiple-data="onRecordMultipleData"
      @record-program-data="onRecordProgramData"
    />
    <interval-data
      v-else-if="isIntervalChild"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-multiple-data="onRecordMultipleData"
      @record-program-data="onRecordProgramData"
    />
    <duration-data
      v-else-if="isDuration"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      :session-paused="sessionPaused"
      :session-duration-offset="sessionDurationOffset"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
    <rate-data
      v-else-if="isRate"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      :session-paused="sessionPaused"
      :session-duration-offset="sessionDurationOffset"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
    <shaping-target
      v-else-if="isShaping"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :focused="focused"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
    <random-rotation-target
      v-else-if="isRandomRotation"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :focused="focused"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
    <cab-branch-target
      v-else-if="isCabBranch"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :focused="focused"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
    <instructions-target
      v-else-if="isInstructionsTarget"
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :focused="focused"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
    <trial-by-trial-data
      v-else
      ref="target"
      :session-program="sessionProgram"
      :target="target"
      :data="data"
      :active-prompt-levels="activePromptLevels"
      :dense="dense"
      :tiny="tiny"
      :disable="isDisabled"
      :dimmed="isDimmed"
      :focused="focused"
      :workflow-statuses="workflowStatuses"
      :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
      @record="onRecord"
      @record-target="onRecordTarget"
      @record-program-data="onRecordProgramData"
    />
  </span>
</template>
<script>
import CabBranchTarget from 'components/Programs/DataCollection/CabBranchTarget';
import DurationData from 'components/Programs/DataCollection/DurationData';
import InstructionsTarget from 'components/Programs/DataCollection/InstructionsTarget';
import IntervalData from 'components/Programs/DataCollection/IntervalData';
import IntervalTarget from 'components/Programs/DataCollection/IntervalTarget.vue';
import RandomRotationTarget from 'components/Programs/DataCollection/RandomRotationTarget';
import RateData from 'components/Programs/DataCollection/RateData';
import ShapingTarget from 'components/Programs/DataCollection/ShapingTarget';
import TargetSetTarget from 'components/Programs/DataCollection/TargetSetTarget';
import TaskAnalysisTarget from 'components/Programs/DataCollection/TaskAnalysisTarget';
import TrialByTrialData from 'components/Programs/DataCollection/TrialByTrialData';
import { chain, get } from 'lodash';
import DataCollection from 'src/mixins/DataCollection';
import Targets from 'src/mixins/Targets';
import { OUTCOME_MEASUREMENT_TYPES } from 'src/constants/prompt-level-template';
import { TARGET_DATA_TYPE_DEFINITIONS } from 'src/constants/targets';

export default {
  name: 'TargetData',

  components: {
    TrialByTrialData,
    TaskAnalysisTarget,
    TargetSetTarget,
    InstructionsTarget,
    IntervalData,
    DurationData,
    RateData,
    RandomRotationTarget,
    ShapingTarget,
    CabBranchTarget,
    IntervalTarget,
  },

  mixins: [DataCollection, Targets],

  props: {

    paused: {
      type: Boolean,
      default: false,
    },

    dimmed: {
      type: Boolean,
      default: false,
    },

    cachedCurrentProgramTrial: {
      type: Number,
      default: 0,
    },

  },

  emits: ['record', 'record-multiple-data', 'record-program-data'],

  computed: {
    showMultipleSubTargets() {
      return chain(TARGET_DATA_TYPE_DEFINITIONS)
        .find({ value: this.target.dataType })
        .get('showMultipleSubTargets')
        .value();
    },

    isTaskAnalysisTarget() {
      return (['taskAnalysis'].includes(this.target.dataType));
    },

    isTargetSetTarget() {
      return (['targetSet'].includes(this.target.dataType));
    },

    isIntervalParent() {
      return this.target.dataType === 'interval' && !this.target.parentTarget;
    },

    isIntervalChild() {
      const isIntervalProgram = ['interval'].includes(this.sessionProgram.program.type);
      const isIntervalSubTarget = this.target.dataType === 'interval' && !!this.target.parentTarget;
      return isIntervalProgram || isIntervalSubTarget;
    },

    isShaping() {
      return (['shaping'].includes(this.target.dataType));
    },
    isRandomRotation() {
      return (['randomRotation'].includes(this.target.dataType));
    },
    isCabBranch() {
      return (['cabBranch'].includes(this.target.dataType));
    },
    isInstructionsTarget() {
      return (['instructions'].includes(this.target.dataType));
    },
    isDuration() {
      return ['duration'].includes(this.sessionProgram.program.type)
        || (['duration'].includes(this.target.dataType));
    },
    isRate() {
      return ['rate'].includes(this.target.dataType);
    },
    isTaskAnalysis() {
      return ['taskAnalysis'].includes(this.sessionProgram.program.type);
    },
    isFrequencyProgram() {
      return ['frequency'].includes(this.sessionProgram.program.type);
    }, // isFrequencyProgram()

    isRatingScale() {
      return this.programPromptLevelTemplate?.outcomeMeasurement === OUTCOME_MEASUREMENT_TYPES.RATING_SCALE;
    }, // isRatingScale()

  },

  methods: {

    finishSession(finalInterval) {
      if (chain(this.$refs).get(['target', 'finishSession']).isFunction().value()) {
        return this.$refs.target.finishSession(finalInterval);
      }
    }, // finishSession()

    onRecord(data) {
      const preparedData = { ...data };
      if (this.isRatingScale) {
        preparedData.isRatingScale = true;
      }
      this.$emit('record', this.sessionProgram, this.target, preparedData);
    },

    onRecordMultipleData(dataArr) {
      const preparedDataArr = this.isRatingScale && Array.isArray(dataArr)
        ? dataArr.map((item) => (item && typeof item === 'object' ? { ...item, isRatingScale: true } : item))
        : dataArr;
      this.$emit('record-multiple-data', this.sessionProgram, preparedDataArr, this.target);
    }, // onRecordMultipleData()

    onRecordTarget(target, data) {
      const templateId = target?.promptLevelTemplate
        || this.getActivePromptLevelTemplateId(get(this.parentTarget, 'defaultPromptLevelTemplate'))
        || this.sessionProgram.program.promptLevelTemplate;

      const isRating = this.activePromptLevels.find((p) => p.id === templateId)?.outcomeMeasurement
        === OUTCOME_MEASUREMENT_TYPES.RATING_SCALE;

      const preparedData = isRating && data && typeof data === 'object'
        ? { ...data, isRatingScale: true }
        : data;
      this.$emit('record', this.sessionProgram, target, preparedData);
    }, // onRecord()

    onRecordProgramData(sessionProgram, dataObj) {
      this.$emit('record-program-data', sessionProgram, dataObj);
    }, // onRecordProgramData()

    undoData(undoDataItem) {
      if (typeof this.$refs?.target?.undoData === 'function') {
        return this.$refs.target.undoData(undoDataItem);
      }
      return true;
    },

  },
};
</script>
<style lang="scss">
.focused-target {
  border: solid $dark-variant 2px;
}
</style>
